import { vars } from "@imwebme/clay-token";
import type { PropsWithChildren, Ref } from "react";
import { forwardRef } from "react";
import { Flex } from "../..";

export const VisualModalFooter = forwardRef(
  (props: PropsWithChildren, ref: Ref<HTMLDivElement>) => {
    return (
      <Flex.Column
        ref={ref}
        gap={vars.spacing[4]}
        padding={`0 ${vars.spacing[6]} ${vars.spacing[4]}`}
      >
        {props.children}
      </Flex.Column>
    );
  },
);

VisualModalFooter.displayName = "VisualModalFooter";
